import TagManager from 'react-gtm-module';
import { determinePageType } from '@utils/gtm/ga4/utils';

export type BannerStripInteractionLocation = 'footer' | 'body';

const PAGE_TYPE_VALUES: Record<ReturnType<typeof determinePageType>, string> = {
  Homepage: 'homepage',
  CIP: 'cip',
  LP: 'clp',
  PDP: 'pdp',
  PLP: 'plp',
  'Branded Store': 'branded_store',
  unassigned: 'other',
};

export interface TrackBannerStripClickProps {
  data: {
    linkUrl: string;
    linkText: string;
    interactionLocation: BannerStripInteractionLocation;
  };
}

export const trackBannerStripClick = ({ data }: TrackBannerStripClickProps) => {
  const { linkUrl, linkText, interactionLocation } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_banner_strip',
      interaction: {
        link_url: linkUrl,
        link_text: linkText,
        interaction_location: interactionLocation,
        type: PAGE_TYPE_VALUES[determinePageType()],
        event_page: window.location.pathname,
      },
    },
  });
};
